export const SSO_ERROR_MESSAGE = "Couldn't find user with these credentials, please contact support";

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_COMPLEXITY_REG_EXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*.,?]).+$/;
